<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Periodos</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Nueva emisión de nómina</strong>
            </h5>
          </div>
        </div>
        <b-form @submit.prevent="createPeriod">
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="months-group" label-for="months">
                <template v-slot:label>
                  Mes<strong :style="{ color: colorAsterisco }">*</strong>
                </template>
                <b-form-select id="months" v-model="form.month" :options="months" required></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="years-group" label-for="years">
                <template v-slot:label>
                  Año<strong :style="{ color: colorAsterisco }">*</strong>
                </template>
                <b-form-select id="years" v-model="form.year" :options="years" required></b-form-select>
              </b-form-group>
            </div>
          </div>
          <RequiredFields/>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de periodos</strong>
            </h5>
          </div>
          <div class="col">
            <div class="text-right">
              <router-link to="/payrolls/import" class="ant-btn">
                <a-icon type="upload" /> Importar desde Excel
              </router-link>
            </div>
          </div>
        </div>
        <b-row>
          <b-col>
            <b-table v-if="data.length > 0" id="table-periods-payrolls" :per-page="pagination.perPage" :current-page="pagination.currentPage" striped hover :fields="columns" :items="data" head-variant="light" responsive>
              <template #cell(periodPayroll)="payroll">
                <span style="color: #4b7cf3;">
                  <router-link :to="{ path: 'employees/periods', query: { month: payroll.item.month, year: payroll.item.year } }">
                    {{ payroll.item.periodPayroll }}
                  </router-link>
                </span>
              </template>
              <template #cell(state)="payroll">
                <a-tag :key="payroll.item.key" :color="payroll.item.state === 'En proceso' ? 'orange' : 'green'">
                  {{ payroll.item.state.toUpperCase() }}
                </a-tag>
              </template>
              <template #cell(actions)="payroll">
                <div>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Ver información</span>
                    </template>
                    <router-link
                      :to="{ path: 'employees/periods', query: { month: payroll.item.month, year: payroll.item.year } }"
                      class="btn btn-light mr-2">
                      <i class="fa fa-eye" />
                    </router-link>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Añadir empleado</span>
                    </template>
                    <button type="button" class="btn btn-light mr-2" @click="addEmployees(payroll.item)">
                      <i class="fa fa-user-plus text-blue" />
                    </button>
                  </a-tooltip>
                  <a-tooltip v-show="payroll.item.issued === '0'" placement="top">
                    <template slot="title">
                      <span>Eliminar periodo</span>
                    </template>
                    <span>
                      <button type="button" class="btn btn-light mr-2" @click="deletePeriodPayroll(payroll.item)">
                        <i class="fa fa-trash text-danger" />
                      </button>
                    </span>
                    <!-- <span v-else>
                      <button type="button" class="btn btn-light mr-2" @click="deletePeriodPayroll(payroll.item)">
                        <i class="fa fa-trash text-danger" />
                      </button>
                    </span> -->
                  </a-tooltip>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows"
              :per-page="pagination.perPage" aria-controls="table-periods-payrolls"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalAddEmployees :month="month" :year="year" @refreshData="refreshData"/>
  </div>
</template>
<script>
import apiClient2 from '@/services/axios/v2.js'
import moment from 'moment'
import emptyTable from '@/components/custom/cardEmptyList'
import RequiredFields from '@/components/custom/form/RequiredFields.vue'
import ModalAddEmployees from '@/components/custom/payroll/ModalAddEmployees.vue'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'payrollView',
  components: {
    emptyTable,
    RequiredFields,
    ModalAddEmployees,
  },
  data() {
    return {
      colorAsterisco: '#4b7cf3',
      data: [],
      form: {
        month: null,
        year: null,
      },
      months: [
        {
          value: 1,
          text: 'Enero',
        },
        {
          value: 2,
          text: 'Febrero',
        },
        {
          value: 3,
          text: 'Marzo',
        },
        {
          value: 4,
          text: 'Abril',
        },
        {
          value: 5,
          text: 'Mayo',
        },
        {
          value: 6,
          text: 'Junio',
        },
        {
          value: 7,
          text: 'Julio',
        },
        {
          value: 8,
          text: 'Agosto',
        },
        {
          value: 9,
          text: 'Septiembre',
        },
        {
          value: 10,
          text: 'Octubre',
        },
        {
          value: 11,
          text: 'Noviembre',
        },
        {
          value: 12,
          text: 'Diciembre',
        },
      ],
      years: [],
      columns: [
        {
          label: 'Mes',
          key: 'periodPayroll',
        },
        {
          label: 'Nóminas',
          key: 'totalPayrolls',
        },
        {
          label: 'Notas de Ajuste',
          key: 'totalAdjustmentNotes',
        },
        {
          label: 'Emitidos',
          key: 'issued',
        },
        {
          label: 'Por emitir',
          key: 'toIssue',
        },
        {
          label: 'Por corregir',
          key: 'toCorrect',
        },
        {
          label: 'Estado',
          key: 'state',
        },
        {
          label: 'Acciones',
          key: 'actions',
        },
      ],
      month: null,
      year: null,
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
    }
  },
  created() {
    apiClient2.get('payrolls/periods').then((res) => {
      const { data } = res.data
      if (res.data.success) {
        if (Array.isArray(data)) {
          this.data = data.map((p, i) => {
            const date = new Date(p.month + '-1' + '-' + p.year)
            const formattedPeriod = moment(date).locale('es').format('MMMM YYYY')
            return {
              key: i + 1,
              periodPayroll: formattedPeriod[0].toUpperCase() + formattedPeriod.slice(1),
              totalPayrolls: p.totalPayrolls,
              totalAdjustmentNotes: p.totalAdjustmentNotes,
              issued: p.issued,
              toIssue: p.toIssue,
              toCorrect: p.toCorrect,
              month: p.month,
              year: p.year,
              state: p.state,
            }
          })
        }
      } else {
        alert('Hubo un error en el servidor al traer las nóminas!')
      }
    }).catch(e => {
      console.log(e)
    })
    this.months.unshift({ value: null, text: 'Seleccione una opción' })
    this.years.unshift({ value: null, text: 'Seleccione una opción' })

    const productionYear = 2024
    const currentYear = new Date().getFullYear()
    for (let year = productionYear; year <= currentYear; year++) {
      // Creo el selector de años
      this.years.push({
        value: year,
        text: String(year),
      })
    }
  },
  methods: {
    getNameMonth(month) {
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      return months[month - 1]
    },
    deletePeriodPayroll(periodPayroll) {
      apiClient2.delete(`payrolls/periods/month/${periodPayroll.month}/year/${periodPayroll.year}`).then((res) => {
        if (res.data.success) {
          Toast.fire({
            icon: 'success',
            title: res.data.message,
          })
          this.refreshData()
        } else {
          alert('Hubo un error en el servidor al eliminar el periodo')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    refreshData() {
      apiClient2.get('payrolls/periods').then((res) => {
        const { data } = res.data
        if (res.data.success) {
          if (Array.isArray(data)) {
            this.data = data.map((p, i) => {
              const date = new Date(p.month + '-1' + '-' + p.year)
              const formattedPeriod = moment(date).locale('es').format('MMMM YYYY')
              return {
                key: i + 1,
                periodPayroll: formattedPeriod[0].toUpperCase() + formattedPeriod.slice(1),
                totalPayrolls: p.totalPayrolls,
                totalAdjustmentNotes: p.totalAdjustmentNotes,
                issued: p.issued,
                toIssue: p.toIssue,
                toCorrect: p.toCorrect,
                month: p.month,
                year: p.year,
                state: p.state,
              }
            })
          }
        } else {
          alert('Hubo un error en el servidor al traer las nóminas!')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    createPeriod() {
      apiClient2.post('payrolls', {
        period: {
          month: this.form.month,
          year: this.form.year,
        },
      }).then((res) => {
        if (res.data.success) {
          Toast.fire({
            icon: 'success',
            title: res.data.message,
          })
          this.refreshData()
          // Clear form
          this.form = {
            month: null,
            year: null,
          }
        } else {
          alert('Hubo un error en el servidor al crear el periodo')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    addEmployees(payroll) {
      const { month, year } = payroll
      this.month = month
      this.year = year
      this.$bvModal.show('modal-add-employee')
    },
  },
}
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}</style>
